import './index.scss';

export default class Popover {
  constructor(el, option) {
    // 默认配置
    const defOption = {
      placement: 'top',
      align: 'center',
    };

    this.el = el;
    this.option = {
      ...defOption,
      ...option,
    };
    // 若option的选项嵌套了复杂对象，需要用深拷贝来缓存
    this.cacheOption = { ...this.option };
    this.content = this.option.content;
    this.popover = null;
    this.rect = null;
    this.timer = null;
    this.active = false;
    this.init();
  }
  init() {
    this.el.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.el.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    // 增加一个兼容处理，确保删除popover弹层
    this.el.addEventListener(
      'DOMNodeRemoved',
      this.handleMouseLeave.bind(this),
    );
  }
  // 挂载后，popover绑定事件
  initPopoverEvent() {
    if (!this.popover) {
      throw new Error('请指定挂载对象');
    }

    this.popover.addEventListener(
      'mouseenter',
      this.handleMouseEnter.bind(this),
    );
    this.popover.addEventListener(
      'mouseleave',
      this.handleMouseLeave.bind(this),
    );

    // callback
    this.option.onClick &&
      this.popover.addEventListener('click', this.option.onClick);
  }
  handleMouseEnter() {
    if (this.timer) window.clearTimeout(this.timer);
    this.active = true;
    if (!this.popover) {
      this.mount();
    }
  }
  handleMouseLeave() {
    this.timer = window.setTimeout(() => {
      this.unMount();
      this.active = false;
    });
  }
  mount() {
    this.popover = document.createElement('div');
    // 支持Dom String和 Dom对象
    if (typeof this.content === 'string') {
      this.popover.innerHTML = this.content;
    } else {
      this.popover.append(this.content ?? '');
    }

    this.popover.className = `ts-popover ${this.option.placement ?? ''}`;
    // 注意这里需先渲染，后续才能拿到定位和尺寸信息
    document.body.appendChild(this.popover);

    this.initPopoverEvent();
    this.initRect();
    this.layout();
  }
  unMount() {
    this.popover && document.body.removeChild(this.popover);
    this.popover = null;
  }
  close() {
    this.handleMouseLeave();
  }
  // 获取 & 缓存 元素位置尺寸信息
  initRect() {
    if (!this.popover) {
      throw new Error('请指定挂载对象');
    }

    this.rect = {
      el: this.el.getBoundingClientRect(),
      popover: this.popover.getBoundingClientRect(),
      body: document.body.getBoundingClientRect(),
    };
  }
  layout() {
    if (!this.popover || !this.rect) {
      throw new Error('请指定挂载对象');
    }

    const { popover: popoverRect, body: bodyRect } = this.rect;
    /**
     * 边界判断
     */
    // 重置因边界改动的位置设置
    this.option.align = this.cacheOption.align;
    let position = this.calcPosition();
    if (position.left < popoverRect.width) {
      // 超过左边界
      this.option.align = 'left';
      position = this.calcPosition();
    }
    if (position.left + popoverRect.width > bodyRect.width) {
      // 超过右边界
      this.option.align = 'right';
      position = this.calcPosition();
    }
    if (position.top + popoverRect.height > bodyRect.height) {
      // 超过下边界
      this.option.placement = 'top';
      this.popover.classList?.add('top');
      position = this.calcPosition();
    }

    this.popover.style.top = `${position.top}px`;
    this.popover.style.left = `${position.left}px`;
  }
  // 计算位置
  calcPosition() {
    if (!this.popover || !this.rect) {
      throw new Error('请指定挂载对象');
    }

    const { el: elRect, popover: popoverRect, body: bodyRect } = this.rect;
    let top = 0;
    let left = 0;
    switch (this.option.placement) {
      case 'top':
        top = elRect.top - popoverRect.height - bodyRect.top;
        break;
      case 'bottom':
        top = elRect.top + elRect.height - bodyRect.top;
        break;

      default:
        break;
    }

    switch (this.option.align) {
      case 'center':
        left =
          elRect.left +
          elRect.width / 2 -
          popoverRect.width / 2 -
          bodyRect.left;

        break;
      case 'left':
        left = elRect.left - bodyRect.left;
        break;
      case 'right':
        left = elRect.left + elRect.width - popoverRect.width - bodyRect.left;
        break;

      default:
        break;
    }
    return {
      top,
      left,
    };
  }
}
